const deepClone = element => JSON.parse(JSON.stringify(element));

export { deepClone };
